import { all, takeLatest } from 'redux-saga/effects';

import * as actionTypes from '../actionTypes';

import { getCurrentUser } from './getCurrentUser';
import { getFeatures } from './getFeatures';
import { getUserPersonalisation } from './getUserPersonalisation';
import { getUserWebAnalytics } from './getUserWebAnalytics';
import { closeChatbotSaga, openSupportFormSaga } from './openSupportFormSaga';
import { postGoogleAnalyticsId } from './postGoogleAnalyticsId';
import { updateUser } from './updateUser';
import { updateUserEmail } from './updateUserEmail';
import { updateUserPersonalisation } from './updateUserPersonalisation';

export default function* watchUser() {
    yield all([
        takeLatest(actionTypes.GET_CURRENT_USER_REQUEST, getCurrentUser),
        takeLatest(actionTypes.UPDATE_USER_REQUEST, updateUser),
        takeLatest(actionTypes.UPDATE_USER_EMAIL, updateUserEmail),
        takeLatest(actionTypes.GET_USER_FEATURES, getFeatures),
        takeLatest(actionTypes.POST_GOOGLE_ANALYTICS_ID, postGoogleAnalyticsId),
        takeLatest(actionTypes.GET_USER_PERSONALISATION_REQUEST, getUserPersonalisation),
        takeLatest(actionTypes.UPDATE_USER_PERSONALISATION_REQUEST, updateUserPersonalisation),
        takeLatest(actionTypes.OPEN_SUPPORT_FORM_REQUEST, openSupportFormSaga),
        takeLatest(actionTypes.GET_USER_WEB_ANALYTICS_REQUEST, getUserWebAnalytics),
        takeLatest(actionTypes.CLOSE_CHATBOT, closeChatbotSaga),
    ]);
}
